import {FC} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {Link} from '@mui/material';
import {MRT_ColumnDef} from 'material-react-table';

import {
  Currency,
  useGetCurrencies,
  useGetCurrencyEventSchedules,
} from '@entities/currency';
import {MrTable} from '@shared/components';
import {
  entityTableCommonProps,
  ROUTE__CRYPTO_CURRENCY_DETAILS,
} from '@shared/constants';

const localStorageKey = 'currenciesTable';

const CurrencySchedulesCount: FC<{currencyId: string}> = ({currencyId}) => {
  const {data: total} = useGetCurrencyEventSchedules(
    {currencyId, page: 1, pageSize: 1},
    {select: data => data.total},
  );

  return <>{total ?? '—'}</>;
};

const columns: MRT_ColumnDef<Currency>[] = [
  {
    accessorKey: 'slug',
    header: 'Slug',
    enableSorting: false,
    Cell: ({row}) => {
      const currency = row.original;

      return (
        <Link
          component={RouterLink}
          to={ROUTE__CRYPTO_CURRENCY_DETAILS.replace(
            ':currency_id',
            currency.id,
          )}
          state={{currency}}
        >
          {currency.slug}
        </Link>
      );
    },
  },
  {
    accessorKey: 'coingeckoId',
    header: 'Coingecko ID',
    enableSorting: false,
  },
  {
    accessorKey: 'coingeckoNetwork',
    header: 'Coingecko network',
    enableSorting: false,
  },
  {
    accessorKey: 'coingeckoTokenAddress',
    header: 'Coingecko token address',
    enableSorting: false,
  },
  {
    accessorKey: 'isActive',
    header: 'Active',
    enableSorting: false,
    Cell: ({row}) => (row.original.isActive ? 'Yes' : 'No'),
  },
  {
    id: 'schedulesCount',
    header: 'Schedules',
    size: 140,
    enableSorting: false,
    Cell: ({row}) => <CurrencySchedulesCount currencyId={row.original.id} />,
  },
];

export const CurrenciesPage = () => {
  const {data, isPending, error} = useGetCurrencies();

  return (
    <MrTable
      error={error}
      columns={columns}
      data={data ?? []}
      localStorageKeyForSettings={localStorageKey}
      enableHiding
      enablePagination
      state={{
        isLoading: isPending,
      }}
      {...entityTableCommonProps}
      enableRowActions={false}
    />
  );
};
